import { connect } from '@ardoq/rxbeach';
import {
  SidebarMenu,
  SidebarMenuMenu,
  SidebarMenuSection,
} from '@ardoq/sidebar-menu';
import { componentOptions$ } from './componentOptions$';
import { ComponentOptionsProps } from './types';

const ComponentOptionsBase = (props: ComponentOptionsProps) => {
  if (props.mode === 'error') {
    return <SidebarMenu emptyContentMessage={props.message} />;
  }

  const {
    actionOptions,
    editComponentOptions,
    editComponentSectionTitle,
    actionsSectionTitle,
  } = props;

  return (
    <SidebarMenu>
      <SidebarMenuSection
        title={editComponentSectionTitle}
        isCollapsible={false}
      >
        <SidebarMenuMenu options={editComponentOptions} />
      </SidebarMenuSection>
      {actionOptions.length > 0 && (
        <SidebarMenuSection title={actionsSectionTitle} isCollapsible={false}>
          <SidebarMenuMenu options={actionOptions} />
        </SidebarMenuSection>
      )}
    </SidebarMenu>
  );
};
export const ComponentOptions = connect(
  ComponentOptionsBase,
  componentOptions$
);
